import axios from '../../../../../utils/axios'
import actionType from './action'


export const getNotificationData = () => async dispatch => {
    let response = await axios.get(`/notification`)
    dispatch({ type: actionType.GET_NOTIFICATION_DATA, payload: response.data.response.data })
}